module.exports = __webpack_public_path__ + "img/one_single_select.2b44d2aa.png";